import {Injectable} from "@angular/core";
import {NormalizerI} from "./normalizer.i";

const EMPTY = '';

@Injectable()
export class FirstLetterNormalizer implements NormalizerI {
    pattern = /[a-zA-Z]/;
    /**
     * Normalizer for first letter of string
     * @param value
     * @returns {string}
     * Input value example: 5Albania
     * Output value example: Albania
     */
    normalize(value: string): string {
        if (value) {
            for (let i = 0; i < value.length; i++) {
                if (this.pattern.test(value[i])) {
                    return value.substring(i, value.length);
                }
            }
        }
        return EMPTY;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/first-letter-normalizer.service.ts